import React from 'react';
import { Gift, Key, Target, Wallet } from 'lucide-react';
import styles from './GiftCardInfoCards.module.css';

/**
 * GiftCardInfoCards Component
 * 4 informational cards explaining the gift card system
 */
const GiftCardInfoCards = () => {
  const cards = [
    {
      id: 1,
      icon: <Gift size={32} />,
      title: 'Activate Gift Card',
      description: 'Enter your unique activation code to activate your gift card voucher and start earning rewards.',
      gradient: 'linear-gradient(135deg, #F97316 0%, #DC2626 100%)',
    },
    {
      id: 2,
      icon: <Key size={32} />,
      title: 'Complete Requirements',
      description: 'Some gift cards may require a minimum deposit or wager requirement to be completed before claiming.',
      gradient: 'linear-gradient(135deg, #9333EA 0%, #7C3AED 100%)',
    },
    {
      id: 3,
      icon: <Target size={32} />,
      title: 'Track Your Progress',
      description: 'Monitor your wager progress in real-time. Complete the required turnover to unlock your rewards.',
      gradient: 'linear-gradient(135deg, #1E3A8A 0%, #2563EB 100%)',
    },
    {
      id: 4,
      icon: <Wallet size={32} />,
      title: 'Claim Your Rewards',
      description: 'Once all requirements are met, claim your gift card and the amount will be added to your wallet balance.',
      gradient: 'linear-gradient(135deg, #7C3AED 0%, #9333EA 100%)',
    },
  ];

  return (
    <div className={styles.cardsContainer}>
      <h2 className={styles.sectionTitle}>How Gift Cards Work</h2>
      <div className={styles.cardsGrid}>
        {cards.map((card) => (
          <div key={card.id} className={styles.card}>
            <div 
              className={styles.cardGradient}
              style={{ background: card.gradient }}
            ></div>
            <div className={styles.cardContent}>
              <div className={styles.cardIcon}>
                {card.icon}
              </div>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardDescription}>{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GiftCardInfoCards;
